import { useTranslation } from 'hooks';
import PropTypes from 'prop-types';
import React, {useCallback, useEffect, useState} from 'react';
import { NavLinkActive, UploadButton, AttachmentContainer, FileUploadComponent } from 'components/pages/RegistrationPage/style';

function Attachment({ inputProps, value, syncing, loading, useInput, uploadedFileName }) {
  const { t } = useTranslation();
    const [displayErrors, setDisplayErrors] = useState();
    const [fileName, setFileName] = useState();
    var {error: fileErrors, onChange: onfileChange} = useInput('attachmentFile');

    useEffect(() => {
        window.addEventListener("beforeunload", saveToLocal);
        return () => {
            window.removeEventListener("beforeunload", saveToLocal);
        };
    }, []);

    const saveToLocal = (e) => {
        localStorage.setItem('regUploadedFileName', '');
        e.preventDefault();
        e.returnValue = "";
    };
    const handleFileChange = useCallback(
        event => {
            if(event.target.files[0] &&  event.target.files[0].size/1024/1024 > 10) {
                document.getElementById("attachmentFile").value = "";
                if(event.target && event.target.files && event.target.files[0]) {
                    event.target.files[0].size = 0;
                }
                setDisplayErrors(t('label.maxUploadSizeError'));
            }else {
                setDisplayErrors('');
            }
            if(event.target.files[0] && event.target.files[0].name) {
                uploadedFileName.name = event.target.files[0].name;
                localStorage.setItem('regUploadedFileName', event.target.files[0].name);
                setFileName(event.target.files[0].name);
            }else {
                uploadedFileName.name = '';
                localStorage.setItem('regUploadedFileName', '');
                setFileName('');
            }
            onfileChange(event);
        },
        [onfileChange]
    );


    const storedName = localStorage.getItem('regUploadedFileName');
    uploadedFileName.name = (storedName !== undefined && storedName !== '')  ? storedName : '';


  return (
    <AttachmentContainer>
        <UploadButton
            color="primary"
            disabled={loading || syncing}
            label={t('label.uploadCV')}

        />
        {!fileErrors && displayErrors ? <p style={{ color: 'red' }}>{displayErrors}</p> : null}
        {fileErrors ? <p style={{ color: 'red' }}>{t('label.uploadDocRequired')}</p> : null}
      <NavLinkActive component="p">
        {uploadedFileName.name !== '' ? uploadedFileName.name: ''}
      </NavLinkActive>
      <FileUploadComponent
        id="attachmentFile"
       oname="attachmentFile"
        type="file"
        {...useInput('attachmentFile')}
        onChange={handleFileChange}
        {...inputProps}
      />
    </AttachmentContainer>
  );
}

Attachment.propTypes = {
  error: PropTypes.string,
  inputProps: PropTypes.object,
};

export default Attachment;
